import type { FC, ReactNode } from "react"
import React from "react"
import { AccordionItem } from "@chakra-ui/react"

type CreateProposalStepProps = {
  children: ReactNode
}

const CreateProposalStep: FC<CreateProposalStepProps> = ({ children }) => {
  return (
    <AccordionItem
      _notFirst={{
        mt: 4,
      }}
      border="none"
      boxShadow="elevation.2"
    >
      {children}
    </AccordionItem>
  )
}

export default CreateProposalStep
